export interface CountryInfo {
  country_code: string;
  country_name: string;
  country_flag: string;
}

export const COUNTRY_STORAGE_KEY = "country";

export function parseCountryInfo(value: string | null): CountryInfo | null {
  if (!value) return null;

  try {
    const parsed = JSON.parse(value) as Partial<CountryInfo>;
    if (
      typeof parsed.country_code !== "string" ||
      typeof parsed.country_name !== "string" ||
      typeof parsed.country_flag !== "string"
    ) {
      return null;
    }

    return createCountryInfo(
      parsed.country_code,
      parsed.country_name,
      parsed.country_flag,
    );
  } catch {
    return null;
  }
}

export function countryCodeToFlag(code: string): string {
  if (!/^[A-Za-z]{2}$/.test(code)) return "";
  return [...code.toUpperCase()]
    .map((character) => String.fromCodePoint(character.charCodeAt(0) + 127397))
    .join("");
}

export function createCountryInfo(
  countryCode: string,
  countryName: string,
  countryFlag?: string,
): CountryInfo | null {
  const country_code = countryCode.trim().toUpperCase();
  const country_name = countryName.trim();
  if (!country_code || !country_name) return null;

  return {
    country_code,
    country_name,
    country_flag: countryFlag?.trim() || countryCodeToFlag(country_code),
  };
}

export async function detectCountry(): Promise<CountryInfo | null> {
  try {
    const response = await fetch("https://ipapi.co/json/");
    if (!response.ok) return null;
    const data = (await response.json()) as {
      country_code?: string;
      country_name?: string;
    };
    return createCountryInfo(data.country_code ?? "", data.country_name ?? "");
  } catch {
    return null;
  }
}

export function getFlagUrl(
  countryCode: string | null | undefined,
): string | null {
  if (!countryCode || typeof countryCode !== "string") return null;
  const normalizedCode = countryCode.trim().toLowerCase();
  return /^[a-z]{2}$/.test(normalizedCode)
    ? `/assets/flags/${normalizedCode}.svg`
    : null;
}
